import { AlertTriangle, ArrowRight, Settings } from 'lucide-react';
import { Button } from '../ui/button';

export default function TenantSetupGateNotice({
  gate,
  title = 'Workspace setup required',
  compact = false,
}) {
  if (!gate) return null;

  const missingFields = gate.missingFields || [];
  const settingsPath = gate.settingsPath || '/portal/settings';

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-amber-950" data-testid="tenant-setup-gate-notice">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-amber-100">
          <AlertTriangle className="h-4 w-4 text-amber-700" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-semibold">{title}</p>
          <p className="mt-1 text-sm text-amber-800">
            {gate.message || 'Finish Workspace Settings before continuing.'}
          </p>

          {missingFields.length > 0 && (
            <div className={compact ? 'mt-3 flex flex-wrap gap-2' : 'mt-3 grid gap-2 sm:grid-cols-2'}>
              {missingFields.map((field) => (
                <div
                  key={field.key || field.label}
                  className="rounded-md border border-amber-200 bg-white/70 px-3 py-2 text-sm text-amber-900"
                >
                  {field.label || field.key}
                </div>
              ))}
            </div>
          )}

          <Button
            asChild
            size="sm"
            className="mt-4 bg-amber-700 text-white hover:bg-amber-800"
          >
            <a href={settingsPath}>
              <Settings className="mr-2 h-4 w-4" />
              Fix in Workspace Settings
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
}
